import React from 'react';

const UserProfilePhoneInput = ({input, label, type, meta: {touched, error, warning}}) => {
    const formGroupErrorClass = error ? 'has-danger' : '';
    const inputErrorClass = error ? 'form-control-danger' : '';

    return (
        <div className={`form-group row ${formGroupErrorClass}`}>
            <div className="col-sm-12">
                {label}
                <div className="input-group mb-2 mr-sm-2 mb-sm-0">
                <div className="input-group-addon phone-code-placeholder">+45</div>
                <input
                    {...input}
                    className={`form-control ${inputErrorClass}`}
                    type={type}
                />
                <div className="form-control-feedback">{error}</div>
                </div>
            </div>
        </div>
    );
};

export default UserProfilePhoneInput;




// WEBPACK FOOTER //
// ./web/src/components/users/UserProfilePhoneInput.jsx